import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { AssessmentSaveForm } from "../../sub_components/assessment/SaveForm";
import { AssessmentInviteWorker } from "../../sub_components/assessment/InviteWorker";
import AssessmentDetailsLayout from "../../layouts/details/Assessment";

import { useGetAssessmentDetails } from "../../../hooks/assessments";

import { IAssessmentData } from "../../../interfaces/assessment";

const AssessmentSavePage = () => {
    const { assessment_id } = useParams();

    const [assessmentId, setAssessmentId] = useState<number | null>(null);
    const [formData, setFormData] = useState<IAssessmentData>({
        id: null,
        employer: { value: { value: '', label: '' }, error: '' },
        location: { value: { value: '', label: '' }, error: '' },
        jobTitle: { value: { value: '', label: '' }, error: '' },
        description: { value: '', error: '' },
        wageMin: { value: '', error: '' },
        wageMax: { value: '', error: '' },
        wageType: { value: { value: '', label: '' }, error: '' },
        specialized: { value: { value: '', label: '' }, error: '' },
        experience: { value: { value: '', label: '' }, error: '' },
        fullTime: { value: { value: '', label: '' }, error: '' },
        unionized: { value: { value: '', label: '' }, error: '' },
        ipRelated: { value: { value: '', label: '' }, error: '' },
        overseasLocation: { value: { value: '', label: '' }, error: '' },
        otherCountry: { value: { value: '', label: '' }, error: '' },
        isRecordedWorker: { value: { value: '', label: '' }, error: '' },
        worker: { value: { value: '', label: '' }, error: '' },
        workerName: { value: '', error: '' },
    });
    const [mainView, setMainView] = useState<'form' | 'invite'>('form');

    const { data: assessment, isLoading, error } = useGetAssessmentDetails(assessmentId);

    useEffect(() => {
        if (assessment_id) {
            setAssessmentId(Number(assessment_id));
        };
    }, [assessment_id]);

    return (
        <AssessmentDetailsLayout
            operation={!assessmentId ? 'create' : 'update'}
            currentTab="Details"
            title={!assessmentId ? 'Create Role' : (assessment?.title ?? 'Assessment Information')}
            error={!assessmentId ? false : !!error}
        >
            {mainView === 'form' &&
                <AssessmentSaveForm
                    operation={!assessmentId ? 'create' : 'update'}
                    setAssessmentId={setAssessmentId}
                    isLoading={!assessmentId ? false : isLoading}
                    assessmentData={assessment ?? null}
                    formData={formData}
                    setFormData={setFormData}
                    setMainView={setMainView}
                />
            }
            {mainView === 'invite' &&
                <AssessmentInviteWorker
                    assessmentData={assessment ?? null}
                    resetMainView={() => setMainView('form')}
                />
            }
        </AssessmentDetailsLayout>
    );
};

export default AssessmentSavePage;